:host ion-list {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}

ion-list-header,
ion-label {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}

ion-list ion-radio {
  opacity: 0;
}

ion-item {
  --inner-border-width: 0;
}

.item-radio-checked {
  --background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.08);
  --background-focused: var(--ion-color-primary, #3880ff);
  --background-focused-opacity: 0.2;
  --background-hover: var(--ion-color-primary, #3880ff);
  --background-hover-opacity: 0.12;
}

.item-checkbox-checked {
  --background-activated: var(--ion-item-color, var(--ion-text-color, #000));
  --background-focused: var(--ion-item-color, var(--ion-text-color, #000));
  --background-hover: var(--ion-item-color, var(--ion-text-color, #000));
  --color: var(--ion-color-primary, #3880ff);
}